/**
 * Целевые позиции мячей из duck/obstacles/mod.svg (viewBox 543×1102).
 * Берём 10 из 20 `#ball*` (каждый второй) — −50% плотности.
 * Координаты — доли оверлея в процентах (центр + ширина = диаметр / 543).
 */
export type DuckBallOverlayTarget = {
  xPct: number;
  yPct: number;
  sizePct: number;
};

export const DUCK_BALL_OVERLAY_TARGETS: readonly DuckBallOverlayTarget[] = [
  { xPct: 16.0522, yPct: 51.6477, sizePct: 26.1313 },
  { xPct: 14.2106, yPct: 33.9526, sizePct: 26.1313 },
  { xPct: 83.0872, yPct: 64.8056, sizePct: 26.1313 },
  { xPct: 67.0651, yPct: 10.3591, sizePct: 26.1313 },
  { xPct: 53.9896, yPct: 78.8711, sizePct: 26.1313 },
  { xPct: 50.4903, yPct: 93.2997, sizePct: 26.1315 },
  { xPct: 13.4737, yPct: 11.7207, sizePct: 26.1313 },
  { xPct: 57.3169, yPct: 34.6788, sizePct: 26.1315 },
  { xPct: 60.0611, yPct: 66.8897, sizePct: 29.8466 },
  { xPct: 24.7016, yPct: 41.9351, sizePct: 29.8466 },
] as const;

/** Y-центр ниже нижнего края оверлея (полностью за экраном). */
export function duckBallOffscreenYPct(sizePct: number): number {
  return 100 + sizePct / 2 + 8;
}
